<template>
    <div class="feedback" v-if="visible">
        <slot name="errors" :scope="_self" v-if="$_displayErrors">
            <template v-if="hasInvalidFeedback">
                <div
                    v-html="invalidFeedback"
                    v-bind="errorAttrs"
                    :class="$_invalidClass"
                    v-class="errorClasses"
                />
            </template>
            <template v-else>
                <div
                    v-if="displayFirstErrorOnly"
                    key="first-error-only"
                    v-html="firstError"
                    v-bind="errorAttrs"
                    :class="$_invalidClass"
                    v-class="errorClasses"
                />

                <div
                    v-else
                    v-for="(error, key) in errors"
                    :key="key"
                    v-html="error"
                    v-bind="errorAttrs"
                    :class="$_invalidClass"
                    v-class="errorClasses"
                />
            </template>
        </slot>

        <slot name="warnings" :scope="_self" v-if="$_displayWarnings">
            <div class="warnings">
                <div
                    v-for="(error, key) in warnings"
                    :key="key"
                    v-text="error"
                    v-bind="warningAttrs"
                    :class="'warning ' + $_invalidClass"
                    v-class="warningClasses"
                />
            </div>
        </slot>

        <div :class="$_validClass" v-if="hasValidFeedback">
            <slot name="valid-feedback" :scope="_self">
                {{validFeedback}}
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        $_validClass() {
            return 'valid-' + (this.useTooltips ? 'tooltip' : 'feedback')
        },
        $_invalidClass() {
            return 'invalid-' + (this.useTooltips ? 'tooltip' : 'feedback')
        }
    }
}
</script>

<style scoped>
    .feedback {
        display: inline-block;
        width:100%;
    }

    .feedback .warnings .invalid-feedback.warning {
        color: #DEA953;
    }

    .feedback .warnings .invalid-tooltip.warning {
        background: rgba(255, 193, 7, 0.9);
    }

    .feedback .invalid-feedback,
    .feedback .valid-feedback,
    .feedback .invalid-tooltip,
    .feedback .valid-tooltip {
        display: block;
    }
</style>
